import type { ProposalType, SocialApplyStatus } from "@bbj-types/socialApply/enum";
import type { ISocialApply } from "@bbj-types/socialApply/index.js";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "./axios";
import type { TCommunicationData } from "./types";

export type ISocialApplyPatchBody = {
  status: SocialApplyStatus;
  proposal: {
    type: ProposalType;
    communicationData?: TCommunicationData;
  };
};

export type TSocialApplyPatchResponse = ISocialApply;

export const usePatchSocialApply = () => {
  const [state, execute, cancel] = axios<TSocialApplyPatchResponse, ISocialApplyPatchBody, unknown>(
    {
      url: "/applys/social/:id",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: ObjectId, data: ISocialApplyPatchBody) => {
      return execute({
        url: `/applys/social/${id}`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
